// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
} from '@angular/core';

import {
  IFilterControl,
  SelectableOption,
} from '../../../types/internal-interfaces';
import { CheckboxListConfig } from './checkbox-list-config';

@Component({
  selector: 'checkbox-list',
  templateUrl: 'checkbox-list.component.html',
  styleUrls: ['checkbox-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxListComponent
  implements OnInit, OnChanges, IFilterControl
{
  @Input() configuration: CheckboxListConfig;

  @Output() filterUpdated: EventEmitter<string[]> = new EventEmitter();
  @Output() optionsSelectedCountUpdated: EventEmitter<number> =
    new EventEmitter();

  selectedOptionsCount: number = 0;
  options: SelectableOption[] = [];
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    const hasChanges = this.hasOptionChanges(
      changes.configuration.currentValue,
      changes.configuration.previousValue,
    );
    if (hasChanges) {
      this.options = [];
      changes.configuration.currentValue.options.forEach(
        (option: SelectableOption) => {
          this.options.push({ ...option });
        },
      );
    }
  }

  public setValue(currentOptions: string[]): void {
    currentOptions = currentOptions ?? [];
    this.selectedOptionsCount = 0;
    this.options.forEach((option: SelectableOption) => {
      option.isSelected = currentOptions.indexOf(option.value) > -1;
      if (option.isSelected) {
        this.selectedOptionsCount++;
      }
    });
    this.optionsSelectedCountUpdated.emit(this.selectedOptionsCount);
    this.cdr.detectChanges();
  }

  public handleCheckedFilterOption(option: SelectableOption): void {
    const payload: string[] = [];

    this.selectedOptionsCount = 0;
    this.options.forEach((option: SelectableOption) => {
      if (option.isSelected) {
        payload.push(option.value);
        this.selectedOptionsCount++;
      }
    });

    this.optionsSelectedCountUpdated.emit(payload.length);
    this.filterUpdated.emit(payload);
  }

  public clearAllOptions(): void {
    this.options.forEach((option: SelectableOption) => {
      option.isSelected = false;
    });
    this.selectedOptionsCount = 0;
    this.optionsSelectedCountUpdated.emit(0);
    this.filterUpdated.emit([]);
  }

  private hasOptionChanges(
    current: CheckboxListConfig,
    previous: CheckboxListConfig,
  ): boolean {
    const changed = current.options != previous?.options;
    return changed;
  }
}
